import * as XLSX from "xlsx";

export async function parseTabularFile(file) {
  if (!file) {
    throw new Error("Missing file to parse.");
  }

  const bytes = await file.arrayBuffer();
  const workbook = XLSX.read(bytes, {
    type: "array",
    raw: false,
    cellDates: false,
  });

  const firstSheetName = workbook.SheetNames?.[0];
  if (!firstSheetName) {
    throw new Error("No sheet data found in file.");
  }

  const firstSheet = workbook.Sheets[firstSheetName];
  return XLSX.utils.sheet_to_json(firstSheet, {
    header: 1,
    blankrows: true,
    defval: "",
  });
}
